var path = '/templates/core/views/directives/zc_date_time_picker.html';
var html = "<div class=dropdown dropdown><a class=dropdown-toggle id={{pickerId}} role=button data-toggle=dropdown dropdown-toggle href=#><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> <input type=text class=form-control value=\"{{ data | date: ('sharedModules.dateTimeFormats.datetime' | translate) }}\"></div></a><ul class=dropdown-menu role=menu aria-labelledby=dLabel><datetimepicker data-ng-model=data data-datetimepicker-config=\"{ dropdownSelector: '#'+pickerId, minView: minView }\"></datetimepicker></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/directives/zc_date_time_picker.html
// module id = 1324
// module chunks = 0